import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from './en';

export const i18n = i18next
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // if a language detector is used, do not define the lng option
    lng: 'en',
    resources: {
      en,
    },
    fallbackLng: 'en',
    load: 'languageOnly',
    interpolation: {
      // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
      escapeValue: false,
    },
    debug: import.meta.env.DEV && import.meta.env.MODE !== 'test',
  });
